import { supabase } from "@/lib/supabaseClient";

export const DOCUMENT_TYPES = {
  treatmentPlan: "treatment_plan",
  checkoutReceipt: "checkout_receipt",
  arInvoice: "ar_invoice",
};

export function isSignedDocument(document) {
  return document?.status === "signed" && !!document?.signature;
}

export function signatureForPdf(document) {
  if (!isSignedDocument(document)) return null;
  return {
    imageDataUrl: document.signature.signature_image_data_url,
    signerName: document.signature.signer_name,
    signerRole: document.signature.signer_role,
    signerRelationship: document.signature.signer_relationship,
    staffWitnessName: document.signature.staff_witness_name,
    signedAt: document.signature.signed_at || document.signed_at,
    documentHash: document.document_hash,
  };
}

export async function getSignedDocumentStatus({ documentType, sourceId }) {
  if (!documentType || !sourceId) return null;
  const { data, error } = await supabase.rpc("get_signed_document_status", {
    p_document_type: documentType,
    p_source_id: sourceId,
  });
  if (error) throw error;
  return data || null;
}

export async function getTreatmentPlanDocumentStatus({ planId, createSnapshot = false }) {
  if (!planId) return null;
  const { data, error } = await supabase.rpc("get_treatment_plan_document_status", {
    p_plan_id: planId,
    p_create_snapshot: createSnapshot,
  });
  if (error) throw error;
  return data || null;
}

export async function signTreatmentPlanDocument({
  planId,
  signature,
  acceptPlan = true,
  acceptedItemIds = null,
}) {
  const { data, error } = await supabase.rpc("sign_treatment_plan_document", {
    p_plan_id: planId,
    p_signature: signature,
    p_accept_plan: acceptPlan,
    p_accepted_item_ids: acceptedItemIds,
  });
  if (error) throw error;
  return data;
}

export async function createDocumentSnapshot({
  documentType,
  sourceTable,
  sourceId,
  patientId,
  documentNumber,
  documentTitle,
  documentPayload,
  signatureAnchor = { page: "last", slot: "patient_conforme" },
  documentVersion = "v1",
}) {
  const { data, error } = await supabase.rpc("create_document_snapshot", {
    p_document_type: documentType,
    p_source_table: sourceTable,
    p_source_id: sourceId,
    p_patient_id: patientId || null,
    p_document_number: documentNumber || null,
    p_document_title: documentTitle,
    p_document_payload: documentPayload,
    p_signature_anchor: signatureAnchor,
    p_document_version: documentVersion,
  });
  if (error) throw error;
  return data;
}

export async function signDocumentSnapshot({ documentId, signature }) {
  const { data, error } = await supabase.rpc("sign_document_snapshot", {
    p_document_id: documentId,
    p_signature: signature,
  });
  if (error) throw error;
  return data;
}
